import { unref } from "vue";

export function getSlot(containerOrSlot) {
  if (containerOrSlot?.tagName === "SLOT") {
    return containerOrSlot;
  }

  const firstChild = containerOrSlot?.firstElementChild;

  if (!firstChild || firstChild.tagName !== "SLOT") {
    return undefined;
  }

  return firstChild;
}

export function getSlotContent(slotOrContainer, { flatten = false } = {}) {
  const slot = getSlot(unref(slotOrContainer));
  if (slot) {
    return slot.assignedElements({ flatten });
  }

  return Array.from(unref(slotOrContainer)?.children ?? []);
}

export function hasSlotContent(slot, { deep = false } = {}) {
  const content = getSlotContent(slot, { flatten: true });

  if (content.length === 1 && content[0].tagName === "SLOT") {
    return hasSlotContent(content[0], { deep });
  }

  return content !== undefined && content.length > 0;
}

export function hasSlotContentDeep(slot) {
  return hasSlotContent(slot, { deep: true });
}
